module.exports = __webpack_public_path__ + "static/006-c5c1b40ae24151b53be305f8eb0e75fe.jpeg";